import { render, staticRenderFns } from "./BrokerCommissionPayment.vue?vue&type=template&id=446dd998&scoped=true"
import script from "./BrokerCommissionPayment.vue?vue&type=script&lang=js"
export * from "./BrokerCommissionPayment.vue?vue&type=script&lang=js"
import style0 from "./BrokerCommissionPayment.vue?vue&type=style&index=0&id=446dd998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446dd998",
  null
  
)

export default component.exports